import * as React from "react";
const SvgNumberSpinnerDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 4, viewBox: "0 0 7 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.5 4L0 0H7L3.5 4Z", fill: "currentColor" }));
export { SvgNumberSpinnerDown as ReactComponent };
